module.exports = __webpack_public_path__ + "static/img/003.0105e683.png";